import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return <header className="bg-[#8A9A5B] shadow-sm sticky top-0 z-50" data-id="element-249">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-250">
        <div className="flex justify-between items-center py-4" data-id="element-251">
          <div className="flex items-center" data-id="element-252">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mhSQzqAkdBcNMQ8aCTM7Tt/Gray_Logo.png" alt="Meyer Bookkeeping & Tax Logo" className="h-12 w-auto" data-id="element-253" />
          </div>
          {/* Desktop navigation */}
          <nav className="hidden md:flex space-x-8" data-id="element-254">
            <a href="#services" className="text-white hover:text-gray-200 text-sm font-medium" data-id="element-255">
              Services
            </a>
            <a href="#process" className="text-white hover:text-gray-200 text-sm font-medium" data-id="element-256">
              Process
            </a>
            <a href="#testimonials" className="text-white hover:text-gray-200 text-sm font-medium" data-id="element-257">
              Testimonials
            </a>
            <a href="#about" className="text-white hover:text-gray-200 text-sm font-medium" data-id="element-258">
              About
            </a>
            <a href="#faq" className="text-white hover:text-gray-200 text-sm font-medium" data-id="element-259">
              FAQ
            </a>
            <a href="/contact" className="bg-[#3A4A46] text-white px-4 py-2 rounded hover:bg-opacity-80 transition-colors" data-id="element-260">
              Book a Call
            </a>
          </nav>
          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-261">
            <button onClick={toggleMenu} className="text-white hover:text-gray-200 focus:outline-none" data-id="element-262">
              {isMenuOpen ? <XIcon className="h-6 w-6" data-id="element-263" /> : <MenuIcon className="h-6 w-6" data-id="element-264" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden bg-[#9BAB6C] border-t border-[#79894A]" data-id="element-265">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-266">
            <a href="#services" className="block px-3 py-2 text-base font-medium text-white hover:bg-[#79894A]" onClick={() => setIsMenuOpen(false)} data-id="element-267">
              Services
            </a>
            <a href="#process" className="block px-3 py-2 text-base font-medium text-white hover:bg-[#79894A]" onClick={() => setIsMenuOpen(false)} data-id="element-268">
              Process
            </a>
            <a href="#testimonials" className="block px-3 py-2 text-base font-medium text-white hover:bg-[#79894A]" onClick={() => setIsMenuOpen(false)} data-id="element-269">
              Testimonials
            </a>
            <a href="#about" className="block px-3 py-2 text-base font-medium text-white hover:bg-[#79894A]" onClick={() => setIsMenuOpen(false)} data-id="element-270">
              About
            </a>
            <a href="#faq" className="block px-3 py-2 text-base font-medium text-white hover:bg-[#79894A]" onClick={() => setIsMenuOpen(false)} data-id="element-271">
              FAQ
            </a>
            <a href="/contact" className="block px-3 py-2 text-base font-medium bg-[#3A4A46] text-white rounded" onClick={() => setIsMenuOpen(false)} data-id="element-272">
              Book a Call
            </a>
          </div>
        </div>}
    </header>;
}